import { __exports as u } from "./index.es87.js";
import { __require as o } from "./index.es88.js";
import { __require as L } from "./index.es89.js";
var M;
function j() {
  return M ? u : (M = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXMLStrict = e.decodeHTML5Strict = e.decodeHTML4Strict = e.decodeHTML5 = e.decodeHTML4 = e.decodeHTMLStrict = e.decodeHTML = e.decodeXML = e.encodeHTML5 = e.encodeHTML4 = e.escapeUTF8 = e.escape = e.encodeNonAsciiHTML = e.encodeHTML = e.encodeXML = e.encode = e.decodeStrict = e.decode = void 0;
    var t = o(), i = L();
    function f(r, n) {
      return (!n || n <= 0 ? t.decodeXML : t.decodeHTML)(r);
    }
    e.decode = f;
    function T(r, n) {
      return (!n || n <= 0 ? t.decodeXML : t.decodeHTMLStrict)(r);
    }
    e.decodeStrict = T;
    function b(r, n) {
      return (!n || n <= 0 ? i.encodeXML : i.encodeHTML)(r);
    }
    e.encode = b;
    var d = L();
    Object.defineProperty(e, "encodeXML", { enumerable: !0, get: function() {
      return d.encodeXML;
    } }), Object.defineProperty(e, "encodeHTML", { enumerable: !0, get: function() {
      return d.encodeHTML;
    } }), Object.defineProperty(e, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
      return d.encodeNonAsciiHTML;
    } }), Object.defineProperty(e, "escape", { enumerable: !0, get: function() {
      return d.escape;
    } }), Object.defineProperty(e, "escapeUTF8", { enumerable: !0, get: function() {
      return d.escapeUTF8;
    } }), Object.defineProperty(e, "encodeHTML4", { enumerable: !0, get: function() {
      return d.encodeHTML;
    } }), Object.defineProperty(e, "encodeHTML5", { enumerable: !0, get: function() {
      return d.encodeHTML;
    } });
    var c = o();
    Object.defineProperty(e, "decodeXML", { enumerable: !0, get: function() {
      return c.decodeXML;
    } }), Object.defineProperty(e, "decodeHTML", { enumerable: !0, get: function() {
      return c.decodeHTML;
    } }), Object.defineProperty(e, "decodeHTMLStrict", { enumerable: !0, get: function() {
      return c.decodeHTMLStrict;
    } }), Object.defineProperty(e, "decodeHTML4", { enumerable: !0, get: function() {
      return c.decodeHTML;
    } }), Object.defineProperty(e, "decodeHTML5", { enumerable: !0, get: function() {
      return c.decodeHTML;
    } }), Object.defineProperty(e, "decodeHTML4Strict", { enumerable: !0, get: function() {
      return c.decodeHTMLStrict;
    } }), Object.defineProperty(e, "decodeHTML5Strict", { enumerable: !0, get: function() {
      return c.decodeHTMLStrict;
    } }), Object.defineProperty(e, "decodeXMLStrict", { enumerable: !0, get: function() {
      return c.decodeXML;
    } });
  }(u), u);
}
export {
  j as __require
};
//# sourceMappingURL=index.es82.js.map
